// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-Social-styles--oauthButtons--PCtu6 {
  box-sizing: border-box;
  margin: 0 !important;
  padding: 10px 10px 20px 5px;
  width: auto !important;
  text-align: left !important;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-Social-styles--oauthButtons--PCtu6 {
    margin-left: -5px !important;
    padding: 15px 0 20px;
}
  }

.src-containers-Profile-Social-styles--oauthButtons--PCtu6:empty {
    display: none;
  }

.src-containers-Profile-Social-styles--oauthButtons--PCtu6 > * {
  margin: 5px 0 0 5px !important;
}

.src-containers-Profile-Social-styles--champ--QyRE0 {
  position: relative;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-size: 18px 18px;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='20'%3E%3Cpath fill='%23FF790E' fill-rule='evenodd' d='M0 0h15.514v11.682c0 5.178-7.264 7.605-7.264 7.605s-.246.06-.493.06c-.246 0-.493-.06-.493-.06S0 16.86 0 11.682zm14.301 11.134V1.216H1.212v9.918c0 4.993 6.237 6.923 6.237 6.923s.126.062.308.062c.187 0 .308-.062.308-.062s6.236-1.93 6.236-6.923M8.423 2.687h4.666v8.7c0 1.471-.784 2.62-1.697 3.53-1.315 1.312-2.908 2.008-2.908 2.008h-.06v-6.267s-.304.304-.91.304H5.333c-2.723 0-2.91-1.177-2.91-2.92V2.687h4.182v4.868c0 .243.242.487.485.487h.849c.242 0 .484-.243.484-.487zM4.485 12.18H7.21v4.746h-.06s-1.555-.622-3.03-2.008c-1.004-.944-1.697-2.056-1.697-3.53v-.546c-.006-.044.485 1.338 2.06 1.338z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
}

.src-containers-Profile-Social-styles--avatar--SRBZa {
  margin-top: -10px !important;
  margin-bottom: -10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/Social/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;AAU7B;;AARE;;AAPF;IAQI,4BAA4B;IAC5B,oBAAoB;AAMxB;EALE;;AAEA;IACE,aAAa;EACf;;AAGF;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,4wBAAmC;EACnC,4BAA4B;EAC5B,kCAAkC;EAClC,+CAA6C;AAC/C;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.oauthButtons {\n  box-sizing: border-box;\n  margin: 0 !important;\n  padding: 10px 10px 20px 5px;\n  width: auto !important;\n  text-align: left !important;\n\n  @media (--desktop) {\n    margin-left: -5px !important;\n    padding: 15px 0 20px;\n  }\n\n  &:empty {\n    display: none;\n  }\n}\n\n.oauthButtons > * {\n  margin: 5px 0 0 5px !important;\n}\n\n.champ {\n  position: relative;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  background-size: 18px 18px;\n  background-image: url('./logo.svg');\n  background-repeat: no-repeat;\n  background-position: center center;\n  box-shadow: inset 0 0 0 1px rgb(0 0 0 / 0.15);\n}\n\n.avatar {\n  margin-top: -10px !important;\n  margin-bottom: -10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"oauthButtons": `src-containers-Profile-Social-styles--oauthButtons--PCtu6`,
	"champ": `src-containers-Profile-Social-styles--champ--QyRE0`,
	"avatar": `src-containers-Profile-Social-styles--avatar--SRBZa`
};
module.exports = ___CSS_LOADER_EXPORT___;
